export default __webpack_public_path__ + "static/soehne-web-dreiviertelfett-kursiv-96912e6527bb8aca0c3e58f3287eb7c7.woff2";